import { Directionality } from '@angular/cdk/bidi';
import { ChangeDetectorRef, Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnRerenderOnDirectionChange]',
})
export class RerenderOnDirectionChangeDirective implements OnDestroy, OnInit {
  private subscription: Subscription;

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<any>,
    private readonly cdRef: ChangeDetectorRef,
    private readonly directionality: Directionality
  ) {}

  public ngOnInit(): void {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef);

    this.subscription = this.directionality.change.subscribe(() => {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.cdRef.detectChanges();
    });
  }

  public ngOnDestroy() {
    this.clearSubscription();
  }

  private clearSubscription() {
    this.subscription?.unsubscribe();
  }
}
